import React from "react";
import "./jobs.css";

const jobList = [
    {
        title: "ELEKTRIKER (M/W/D) GESUCHT",
        description: [
            "Ein zukunftsorientiertes Elektrounternehmen mit breitem Leistungsspektrum – von klassischen Elektroinstallationen bis hin zu modernen Smart-Home-Lösungen.",
            "Als Installationspartner von Homematic IP und autorisierter Doorbird-Partner bieten wir unseren Kunden innovative Technik und maßgeschneiderte Lösungen.",
            "Zur Verstärkung unseres Teams suchen wir einen engagierten Elektriker (m/w/d) mit Leidenschaft für das Elektrohandwerk und Interesse an neuen Technologien."
        ],
        benefits: [
            "Abwechslungsreiche Projekte mit modernen Technologien",
            "Angenehmes Betriebsklima in einem engagierten Team",
            "Fort- und Weiterbildungen (z. B. im Bereich Smarthome, Doorbird, Homematic IP) sowie Aufstiegsmöglichkeit",
            "Leistungsgerechte Vergütung",
            "Moderne Arbeitsmittel und hochwertige Arbeitskleidung"
        ]
    }

    // Add more job objects as needed
];

const Jobs = () => {
    return (
        <div className="jobs-wrapper">
            {jobList.map((job, index) => (
                <div key={index} className="job-card">
                    <h2 className="job-title">{job.title}</h2>
                    <div className="job-details-box">
                        <h3>WIR SIND</h3>
                        {job.description.map((para, i) => (
                            <p key={i} className="job-description">{para}</p>
                        ))}
                        <h3>WIR BIETEN</h3>
                        <ul className="job-benefits">
                            {job.benefits.map((benefit, i) => (
                                <li key={i}>✔ {benefit}</li>
                            ))}
                        </ul>
                        <h3>INTERESSE GEWECKT?</h3>
                        <p>Wir freuen uns darauf, Dich kennen zu lernen.</p>
                        <div className="job-contact">
                            <p>
                                <a href="tel:+491753801443">☏ +49 (0) 175 380 1443</a>
                            </p>
                            <p>
                                <a href="mailto:karriere@elektro-krone.de">✉ karriere@elektro-krone.de</a>
                            </p>
                            <p>Klosterstraße 1, 78247 Hilzingen</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Jobs;
